import { render, staticRenderFns } from "./side-menu-desktop.vue?vue&type=template&id=4b77cad4&"
import script from "./side-menu-desktop.vue?vue&type=script&lang=ts&"
export * from "./side-menu-desktop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports